import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Martín G.',
    age: 28,
    city: 'Bariloche',
    initials: 'MG',
    text: 'Estuve clavado en 6c durante dos años. Pensé que necesitaba más fuerza, pero el Tomo 1 me hizo dar cuenta que mi entrenamiento era un desastre. En 3 meses estructurando bien las cargas, por fin encadené mi primer 7a. Una locura.',
    stars: 5
  }, {
    name: 'Lucía R.',
    age: 31,
    city: 'Córdoba',
    initials: 'LR',
    text: 'Me vivía lesionando los dedos. Cada vez que empezaba a progresar, pumba, dolor de polea. El protocolo de prevención y calentamiento específico me salvó. Hace 6 meses que escalo sin molestias.',
    stars: 5
  }, {
    name: 'Javier P.',
    age: 35,
    city: 'Mendoza',
    initials: 'JP',
    text: 'Hacía crossfit y escalada y vivía destruido. El Tomo 4 me abrió la cabeza sobre cómo combinar el gym sin arruinar mi rendimiento en la roca. Ahora me siento mucho más liviano y fuerte en la pared.',
    stars: 4
  }, {
    name: 'Florencia M.',
    age: 26,
    city: 'Buenos Aires',
    initials: 'FM',
    text: 'El manual de antebrazos es oro puro. Siempre me bajaba de las vías porque se me prendían fuego los brazos antes de cansarme de verdad. Cambié la forma de agarrar y los descansos, y la diferencia es abismal.',
    stars: 5
  }, {
    name: 'Sebastián T.',
    age: 33,
    city: 'El Chaltén',
    initials: 'ST',
    text: 'La parte de nutrición y recuperación es clave. Yo comía como si fuera al gimnasio normal y me faltaba energía siempre. Ajusté los carbos y el timing como dice el libro y rindo el doble en la roca. ¡Genios!',
    stars: 5
  }];
  return <section className="py-16 md:py-24 px-4 max-w-6xl mx-auto" data-id="element-158">
      <h2 className="text-4xl md:text-5xl font-bebas text-center mb-12" data-id="element-159">
        LO QUE DICEN{' '}
        <span className="text-orange-500" data-id="element-160">ESCALADORES COMO VOS</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-161">
        {testimonials.map((t, idx) => <div key={idx} className="bg-card border border-gray-800 p-6 rounded-xl flex flex-col" data-id="element-162">
            <div className="flex text-orange-500 mb-4" data-id="element-163">
              {[...Array(t.stars)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-164" />)}
            </div>

            <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-165">"{t.text}"</p>

            <div className="flex items-center gap-4 mt-auto" data-id="element-166">
              <div className="w-10 h-10 rounded-full bg-orange-500/20 text-orange-500 flex items-center justify-center font-bold text-sm" data-id="element-167">
                {t.initials}
              </div>
              <div data-id="element-168">
                <p className="font-bold text-white text-sm" data-id="element-169">
                  {t.name}, {t.age}
                </p>
                <p className="text-xs text-gray-500" data-id="element-170">{t.city}</p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}